document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initSplash();
  initCombo();
  initCompraConProteccion();
  initContador();
  initPopupDescuento();
  initLetras();
  initLuces();
  initBarraCompra();
  initCifra();
  initEntrega();
});

/* Parte los titulares grandes en letras para que entren una a una.
   Se ejecuta ANTES que initReveal para que las letras ya existan cuando el
   observador marque el titular como visible. */
function initLetras() {
  var titulares = document.querySelectorAll('[data-mt-letras]');
  if (!titulares.length) return;

  // Sin animación: se deja el texto tal cual, ni se parte.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  titulares.forEach(function (titular) {
    var texto = titular.textContent.replace(/\s+/g, ' ').trim();
    if (!texto || texto.length > 160) return;

    var n = 0;

    // Recorre el árbol respetando <b>, <em> y <br>: solo toca los nodos de
    // texto, así la negrita y los saltos de línea se mantienen.
    function partir(nodo) {
      var hijos = [].slice.call(nodo.childNodes);
      hijos.forEach(function (hijo) {
        if (hijo.nodeType === 1) {
          partir(hijo);
          return;
        }
        if (hijo.nodeType !== 3) return;

        var contenido = hijo.textContent;
        if (!contenido.trim() && contenido.indexOf(' ') === -1) return;

        // Cada palabra va dentro de su propio envoltorio. Es imprescindible:
        // las letras son inline-block y, sueltas, el navegador puede cortar la
        // palabra por cualquier letra ("mascar / illa"). El envoltorio con
        // nowrap obliga a que el salto de línea caiga solo entre palabras.
        var trozo = document.createDocumentFragment();
        var partes = contenido.split(/(\s+)/);

        partes.forEach(function (parte) {
          if (!parte) return;

          if (/^\s+$/.test(parte)) {
            trozo.appendChild(document.createTextNode(' '));
            return;
          }

          var palabra = document.createElement('span');
          palabra.className = 'mt-palabra';

          for (var i = 0; i < parte.length; i++) {
            var span = document.createElement('span');
            span.className = 'mt-letra';
            span.style.setProperty('--l', n);
            span.textContent = parte[i];
            palabra.appendChild(span);
            n++;
          }

          trozo.appendChild(palabra);
        });

        nodo.replaceChild(trozo, hijo);
      });
    }

    partir(titular);

    if (!n) return;

    // El texto original se conserva como nombre accesible: los lectores de
    // pantalla leen la frase entera, no letra por letra.
    titular.setAttribute('aria-label', texto);
    titular.classList.add('mt-letras-listo');
  });
}

/* La cifra grande cuenta hacia arriba la primera vez que se ve. */
function initCifra() {
  var cifras = document.querySelectorAll('[data-mt-cifra]');
  if (!cifras.length) return;

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sinMovimiento || !('IntersectionObserver' in window)) return;

  function contar(el) {
    var sup = el.querySelector('sup');
    var unidad = sup ? sup.outerHTML : '';
    var destino = parseInt((el.textContent || '').replace(/[^\d]/g, ''), 10);
    if (!destino || destino > 1000000) return;

    var inicio = null;
    var duracion = 1100;

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var avance = Math.min((ahora - inicio) / duracion, 1);
      var suave = 1 - Math.pow(1 - avance, 3);
      el.innerHTML = Math.round(destino * suave).toLocaleString('es-MX') + unidad;
      if (avance < 1) requestAnimationFrame(paso);
    }

    requestAnimationFrame(paso);
  }

  // Se vuelve a contar cada vez que la cifra entra en pantalla, para que al
  // subir de nuevo se vea otra vez el conteo.
  var contando = new WeakMap();

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          if (contando.get(entrada.target)) return;
          contando.set(entrada.target, true);
          contar(entrada.target);
        } else {
          contando.set(entrada.target, false);
        }
      });
    },
    { threshold: 0.6 }
  );

  cifras.forEach(function (c) { observador.observe(c); });
}

/* Los 7 colores: al señalar un color, la rueda deja encendido solo ese. */
function initLuces() {
  var rueda = document.querySelector('[data-mt-rueda]');
  var lista = document.querySelector('[data-mt-luces-lista]');
  if (!lista) return;

  var circulos = rueda ? rueda.querySelectorAll('circle') : [];
  var botones = lista.querySelectorAll('.mt-luz');

  function enfocar(id) {
    if (rueda) rueda.classList.toggle('is-enfocada', !!id);
    lista.classList.toggle('is-enfocada', !!id);
    circulos.forEach(function (c) {
      c.classList.toggle('is-activo', c.getAttribute('data-mt-luz') === id);
    });
    botones.forEach(function (b) {
      b.classList.toggle('is-activo', b.getAttribute('data-mt-luz') === id);
    });
  }

  var manual = false;

  botones.forEach(function (b) {
    var id = b.getAttribute('data-mt-luz');
    function tomar() { manual = true; enfocar(id); }
    function soltar() { manual = false; enfocar(null); }
    b.addEventListener('mouseenter', tomar);
    b.addEventListener('focus', tomar);
    b.addEventListener('click', tomar);
    b.addEventListener('mouseleave', soltar);
    b.addEventListener('blur', soltar);
  });

  // Los colores se encienden solos, uno tras otro. Sin esto el efecto solo
  // existía al pasar el ratón, así que en móvil no se veía nunca.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var seccion = lista.closest('.mt-luces') || lista;
  var enPantalla = false;
  var actual = 0;

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { enPantalla = e.isIntersecting; });
    }, { threshold: 0.25 }).observe(seccion);
  } else {
    enPantalla = true;
  }

  setInterval(function () {
    if (!enPantalla || manual || !botones.length) return;
    actual = (actual + 1) % botones.length;
    enfocar(botones[actual].getAttribute('data-mt-luz'));
  }, 1600);
}

/* Barra de compra fija: aparece al perder de vista el botón principal. */
function initBarraCompra() {
  var barra = document.querySelector('[data-mt-barra-compra]');
  var botonPrincipal = document.querySelector('[data-mt-boton-comprar]');
  if (!barra || !botonPrincipal) return;

  var botonBarra = barra.querySelector('[data-mt-barra-boton]');
  if (botonBarra) {
    botonBarra.addEventListener('click', function () {
      botonPrincipal.click();
    });
  }

  if (!('IntersectionObserver' in window)) return;

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      barra.classList.toggle('is-visible', !entrada.isIntersecting);
    });
  }, { rootMargin: '0px 0px -60px 0px' });

  observador.observe(botonPrincipal);
}

function initPopupDescuento() {
  var popup = document.querySelector('[data-mt-popup]');
  if (!popup) return;

  var LS_KEY = 'mt_popup_descuento_visto';
  var formulario = popup.querySelector('[data-mt-popup-formulario]');
  var exito = popup.querySelector('[data-mt-popup-exito]');
  var codigo = popup.getAttribute('data-codigo');

  function mostrar() {
    popup.classList.add('mt-popup--visible');
  }

  function ocultar() {
    popup.classList.remove('mt-popup--visible');
    try { localStorage.setItem(LS_KEY, '1'); } catch (e) {}
  }

  function mostrarExito() {
    formulario.hidden = true;
    exito.hidden = false;
    mostrar();
    try { localStorage.setItem(LS_KEY, '1'); } catch (e) {}
  }

  popup.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (btn) {
    btn.addEventListener('click', ocultar);
  });

  var copiarBtn = popup.querySelector('[data-mt-popup-copiar]');
  if (copiarBtn) {
    copiarBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(codigo).then(function () {
        var textoOriginal = copiarBtn.textContent;
        copiarBtn.textContent = '¡Copiado!';
        setTimeout(function () { copiarBtn.textContent = textoOriginal; }, 2000);
      });
    });
  }

  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    mostrarExito();
    return;
  }

  var yaVisto = false;
  try { yaVisto = localStorage.getItem(LS_KEY) === '1'; } catch (e) {}
  if (yaVisto) return;

  var segundos = parseInt(popup.getAttribute('data-segundos'), 10) || 12;
  setTimeout(mostrar, segundos * 1000);
}

function initContador() {
  document.querySelectorAll('[data-mt-contador]').forEach(function (el) {
    var horas = parseFloat(el.getAttribute('data-horas')) || 24;
    var duracionMs = horas * 60 * 60 * 1000;
    var key = 'mt_contador_fin';

    var fin = parseInt(localStorage.getItem(key), 10);
    var ahora = Date.now();
    if (!fin || fin < ahora) {
      fin = ahora + duracionMs;
      try { localStorage.setItem(key, String(fin)); } catch (e) {}
    }

    var hEl = el.querySelector('[data-mt-h]');
    var mEl = el.querySelector('[data-mt-m]');
    var sEl = el.querySelector('[data-mt-s]');
    if (!hEl || !mEl || !sEl) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var restante = fin - Date.now();
      if (restante <= 0) {
        fin = Date.now() + duracionMs;
        try { localStorage.setItem(key, String(fin)); } catch (e) {}
        restante = fin - Date.now();
      }
      var totalSeg = Math.floor(restante / 1000);
      var h = Math.floor(totalSeg / 3600);
      var m = Math.floor((totalSeg % 3600) / 60);
      var s = totalSeg % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initCompraConProteccion() {
  var root = document.querySelector('[data-mt-producto]');
  if (!root) return;
  var form = root.querySelector('form[action*="/cart/add"]');
  var boton = root.querySelector('[data-mt-boton-comprar]');
  var botonCarrito = root.querySelector('[data-mt-boton-carrito]');
  var checkbox = root.querySelector('[data-mt-proteccion-checkbox]');
  if (!form || !boton) return;

  // "Comprar ahora" va directo al pago; "Añadir al carrito" pasa por el
  // carrito y lleva la animación de la foto volando.
  var destinoPrincipal = boton.getAttribute('data-destino') === 'carrito' ? '/cart' : '/checkout';
  var ocupado = false;

  function agregar(btn, destino) {
    if (ocupado || btn.hasAttribute('disabled')) return;

    var variantIdInput = form.querySelector('[data-mt-variant-id]');
    var variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
    if (!variantId) return;

    var items = [{ id: variantId, quantity: 1 }];
    if (checkbox && checkbox.checked) {
      var protId = parseInt(checkbox.getAttribute('data-variant-id'), 10);
      if (protId) items.push({ id: protId, quantity: 1 });
    }

    ocupado = true;
    var textoOriginal = btn.textContent.trim();
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Añadiendo…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        btn.classList.add('mt-boton--hecho');

        var espera;
        if (destino === '/checkout') {
          btn.textContent = 'Llevándote al pago…';
          espera = 250;
        } else {
          btn.textContent = '¡Añadido!';
          espera = volarAlCarrito(root);
        }
        setTimeout(function () { window.location.href = destino; }, espera);
      })
      .catch(function () {
        ocupado = false;
        btn.removeAttribute('disabled');
        btn.classList.remove('mt-boton--hecho');
        btn.textContent = textoOriginal;
      });
  }

  form.addEventListener('submit', function (evt) {
    evt.preventDefault();
    agregar(boton, destinoPrincipal);
  });

  if (botonCarrito) {
    botonCarrito.addEventListener('click', function () {
      agregar(botonCarrito, '/cart');
    });
  }
}

/* Fecha estimada de entrega junto al botón. Se calcula en el navegador con la
   fecha de hoy (en Liquid la fecha se queda cacheada) y salta fines de semana.
   Si algo falla, se queda el texto de respaldo que pinta Liquid. */
function initEntrega() {
  var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function sumarHabiles(desde, n) {
    var d = new Date(desde.getTime());
    var sumados = 0;
    while (sumados < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) sumados++;
    }
    return d;
  }

  document.querySelectorAll('[data-mt-entrega]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var texto = el.querySelector('[data-mt-entrega-texto]');
    if (!texto || isNaN(min) || isNaN(max) || max < min) return;

    var hoy = new Date();
    var a = sumarHabiles(hoy, min);
    var b = sumarHabiles(hoy, max);

    var frase;
    if (min === max) {
      frase = 'llega el ' + dias[a.getDay()] + ' ' + a.getDate() + ' de ' + meses[a.getMonth()];
    } else if (a.getMonth() === b.getMonth()) {
      frase = 'llega entre el ' + dias[a.getDay()] + ' ' + a.getDate() +
        ' y el ' + dias[b.getDay()] + ' ' + b.getDate() + ' de ' + meses[b.getMonth()];
    } else {
      frase = 'llega entre el ' + dias[a.getDay()] + ' ' + a.getDate() + ' de ' + meses[a.getMonth()] +
        ' y el ' + dias[b.getDay()] + ' ' + b.getDate() + ' de ' + meses[b.getMonth()];
    }
    texto.textContent = frase;
  });
}

/* La foto del producto sale volando hacia el carrito del header. Devuelve
   cuántos ms hay que esperar antes de ir al carrito, para que dé tiempo a
   verlo. Si falta algo (no hay foto o no hay icono), no se inventa nada:
   devuelve una espera corta y ya. */
function volarAlCarrito(root) {
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var origen = root.querySelector('[data-mt-galeria-principal]') || root.querySelector('img');
  var destino = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');

  if (sinMovimiento || !origen || !destino || !origen.src) return 260;

  var a = origen.getBoundingClientRect();
  var b = destino.getBoundingClientRect();
  if (!a.width || !b.width) return 260;

  var vuela = document.createElement('img');
  vuela.src = origen.currentSrc || origen.src;
  vuela.className = 'mt-vuela';
  vuela.setAttribute('aria-hidden', 'true');
  vuela.style.left = a.left + 'px';
  vuela.style.top = a.top + 'px';
  vuela.style.width = a.width + 'px';
  vuela.style.height = a.height + 'px';
  document.body.appendChild(vuela);

  var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
  var dy = (b.top + b.height / 2) - (a.top + a.height / 2);

  // Dos tramos: primero sube un poco, luego cae hacia el carrito. Da la
  // sensación de arco en vez de una línea recta.
  requestAnimationFrame(function () {
    vuela.style.transform = 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.25 - 60) + 'px) scale(0.55) rotate(-8deg)';
    vuela.style.opacity = '0.95';
  });

  setTimeout(function () {
    vuela.style.transition = 'transform 0.45s cubic-bezier(0.55, 0, 0.85, 0.4), opacity 0.45s ease-in';
    vuela.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.08) rotate(6deg)';
    vuela.style.opacity = '0.2';
  }, 420);

  setTimeout(function () {
    if (vuela.parentNode) vuela.parentNode.removeChild(vuela);
    destino.classList.add('mt-carrito-late');
    setTimeout(function () { destino.classList.remove('mt-carrito-late'); }, 600);
  }, 870);

  return 1150;
}

function initSplash() {
  document.querySelectorAll('[data-mt-splash]').forEach(function (splash) {
    if (splash.classList.contains('mt-splash--oculto-inicial')) return;

    document.body.style.overflow = 'hidden';

    var boton = splash.querySelector('[data-mt-splash-boton]');
    if (!boton) return;

    boton.addEventListener('click', function () {
      splash.classList.add('mt-splash--oculto');
      document.body.style.overflow = '';
      if (splash.getAttribute('data-mostrar-una-vez') === 'true') {
        try {
          sessionStorage.setItem('mt_splash_visto', '1');
        } catch (e) {}
      }
    });
  });
}

function initReveal() {
  var elementos = [].slice.call(document.querySelectorAll('.mt-reveal'));
  if (!elementos.length) return;

  function mostrarTodo() {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
  }

  if (!('IntersectionObserver' in window)) {
    mostrarTodo();
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    mostrarTodo();
    return;
  }

  // El repaso decide en los DOS sentidos: si el elemento está en pantalla se
  // muestra, y si sale por arriba o por abajo se vuelve a esconder. Así, al
  // subir de nuevo, las animaciones se repiten sin recargar la página.
  // Un margen de holgura evita que un elemento justo en el borde parpadee.
  var HOLGURA = 80;

  function repasar() {
    var alto = window.innerHeight;
    elementos.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var dentro = r.top < alto - alto * 0.08 && r.bottom > 0;
      var fuera = r.bottom < -HOLGURA || r.top > alto + HOLGURA;

      if (dentro) {
        el.classList.add('mt-visible');
      } else if (fuera) {
        el.classList.remove('mt-visible');
      }
    });
  }

  // El observador da la reacción inmediata; el intervalo corrige lo que se
  // salte con scroll rápido y lo que quede fuera de pantalla en horizontal.
  // No se usan eventos de scroll: hay contextos donde no llegan a `window`.
  var observer = new IntersectionObserver(repasar, {
    threshold: 0,
    rootMargin: '0px 0px -8% 0px'
  });

  elementos.forEach(function (el) { observer.observe(el); });

  repasar();
  setInterval(repasar, 250);
}

function initGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!full) return;
        principal.src = full;
        principal.alt = alt;
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function initCombo() {
  document.querySelectorAll('[data-mt-combo-add]').forEach(function (btn) {
    var textoOriginal = btn.textContent.trim();
    btn.addEventListener('click', function () {
      var raw = btn.getAttribute('data-ids');
      if (!raw) return;
      var items = raw.split(',').map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = textoOriginal;
        });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = root.querySelector('[data-mt-variant-id]');
    var precioEl = root.querySelector('[data-mt-precio]');
    var precioTachadoEl = root.querySelector('[data-mt-precio-tachado]');
    var boton = root.querySelector('[data-mt-boton-comprar]');
    var pastillaGrupos = root.querySelectorAll('[data-mt-opcion]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    function opcionesSeleccionadas() {
      var seleccion = [];
      pastillaGrupos.forEach(function (grupo) {
        var activa = grupo.querySelector('.is-activa');
        seleccion.push(activa ? activa.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (precioEl) precioEl.textContent = formatMoney(match.price);
      if (precioTachadoEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioTachadoEl.textContent = formatMoney(match.compare_at_price);
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !match.available;
        boton.textContent = match.available
          ? boton.getAttribute('data-texto-disponible')
          : boton.getAttribute('data-texto-agotado');
      }
    }

    pastillaGrupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-mt-pastilla]').forEach(function (pastilla) {
        pastilla.addEventListener('click', function () {
          grupo.querySelectorAll('[data-mt-pastilla]').forEach(function (p) { p.classList.remove('is-activa'); });
          pastilla.classList.add('is-activa');
          actualizar();
        });
      });
    });
  });
}
